'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var dots = {};

exports.__exports = dots;
